// extracted by mini-css-extract-plugin
module.exports = {"Filter_Pills_Wrapper":"DataFilterPills_Filter_Pills_Wrapper__1EZS7"};